import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from '@a-type/ui';
import { isPrefixedId } from '@long-game/common';
import { withGame } from '@long-game/game-client';
import { usePlayerThemed } from '../../players/usePlayerThemed';
import cls from './PlayerHandleChatToken.module.css';
export const PlayerHandleChatToken = withGame(function PlayerHandleChatToken({ gameSuite, token }) {
    if (!isPrefixedId(token.value, 'u')) {
        return '???';
    }
    const player = gameSuite.getPlayer(token.value);
    const playerThemed = usePlayerThemed(player.id);
    return (_jsx("span", { className: clsx(playerThemed.className, cls.root), style: playerThemed.style, children: player.displayName }));
});
//# sourceMappingURL=PlayerHandleChatToken.js.map